import { all, put, takeLatest } from 'redux-saga/effects';
import {
  GET_CATEGORIES,
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
  DISABLE_CATEGORY,
  DELETE_CATEGORY,
} from './constants';
import { onDisplayAlert } from '../../utils/alerts/alerts';
import * as CategoryActions from './actions';
import Api from '../../commons/api';

const controller = 'categories';

function* fetchGetCategories() {
  try {
    const { data: categoryList } = yield Api.get(`${controller}`);
    yield put(CategoryActions.getCategoriesSuccess(categoryList));
  } catch (err) {
    yield put(CategoryActions.getCategoriesFailed(err));
  }
}

function* fetchUpdateCategory({ payload }) {
  try {
    const { category } = payload;
    const { data } = yield Api.put(`${controller}/${controller}/${category.id}`, category);
    yield put(CategoryActions.onUpdateCategorySuccess(data));
    onDisplayAlert({
      title: category.name,
      description: 'Category updated successfully',
      type: 'success',
    });
  } catch (err) {
    onDisplayAlert({
      title: 'Error',
      description: 'Error updating category',
      type: 'error',
    });
    yield put(CategoryActions.onUpdateCategoryFailed(err));
  }
}

function* fetchDisableCategory({ payload }) {
  try {
    const { categoryId, status } = payload;
    const { data } = yield Api.put(`${controller}/${controller}/${categoryId}`, { state: status });
    yield put(CategoryActions.onDisableCategorySuccess(data));
    onDisplayAlert({
      title: 'Category disabled',
      description: 'Category disabled successfully',
      type: 'info',
    });
  } catch (err) {
    onDisplayAlert({
      title: 'Error',
      description: 'Error updating category',
      type: 'error',
    });
    yield put(CategoryActions.onDisableCategoryFailed(err));
  }
}

function* fetchCreateCategory({ payload }) {
  try {
    const { category } = payload;
    const { data } = yield Api.post(`${controller}`, category);
    yield put(CategoryActions.onCreateCategorySuccess(data));
    onDisplayAlert({
      title: category.name,
      description: 'New category created successfully',
      type: 'success',
    });
  } catch (err) {
    onDisplayAlert({
      title: 'Error',
      description: 'Error creating a new category',
      type: 'error',
    });
    yield put(CategoryActions.onCreateCategoryFailed(err));
  }
}

function* fetchDeleteCategory({ payload }) {
  try {
    const { category } = payload;
    yield Api.delete(`${controller}/${controller}/${category.id}`);
    onDisplayAlert({
      title: category.name,
      description: 'Category deleted successfully',
      type: 'info',
    });
    yield put(CategoryActions.onDeleteCategorySuccess(category.id));
  } catch (err) {
    onDisplayAlert({
      title: 'Error',
      description: 'Error deleting category',
      type: 'error',
    });
    yield put(CategoryActions.onDeleteCategoryFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_CATEGORIES, fetchGetCategories);
  yield takeLatest(CREATE_CATEGORY, fetchCreateCategory);
  yield takeLatest(UPDATE_CATEGORY, fetchUpdateCategory);
  yield takeLatest(DISABLE_CATEGORY, fetchDisableCategory);
  yield takeLatest(DELETE_CATEGORY, fetchDeleteCategory);
}

export default function* CategorySaga() {
  yield all([ActionWatcher()]);
}
